import { render, staticRenderFns } from "./AdminSelection.vue?vue&type=template&id=bc741730&"
import script from "./AdminSelection.vue?vue&type=script&lang=js&"
export * from "./AdminSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports